var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(opt){return _c('label',{key:opt.id,staticStyle:{"display":"block","margin":"4px 0"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":opt.id,"checked":_vm.value.includes(opt.id)},on:{"change":function($event){return _vm.onItemChange($event, opt.id)}}}),_vm._v(" "+_vm._s(opt.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }